import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";


export const used_conditions_data = [
    {label : "None", value : " ", key : {}},
    {label : "Used (condition not set)", value : "U", key : KBD.U},
    {label : "Poor", value : "0", key : KBD.Digit0},
    {label : "Acceptable", value : "1", key : KBD.Digit1},
    {label : "Good", value : "2", key : KBD.Digit2},
    {label : "VGood", value : "4", key : KBD.Digit4},
    {label : "LikeNew (Fine)", value : "3", key : KBD.Digit3},
    {label : "New", value : "N", key : KBD.N},
    {label : "CAcceptable (Collectable)", value : "5", key : KBD.Digit5},
    {label : "CGood (Collectable)", value : "6", key : KBD.Digit6},
    {label : "CVGood (Collectable)", value : "8", key : KBD.Digit8},
    {label : "CLikeNew (Collectable)", value : "7", key : KBD.Digit7},

]

export default function UsedConditions(props){

    const {callback = () => {}, value = "", route = ""} = props; 
    const [selected, setSelected] = useState(used_conditions_data.find(item => item.value === value)?.value || " ");

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(selected) } }
    ]

    useEffect(() => {
        const cleanup = listen(route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions])


    const menu = used_conditions_data.map(item => {
        let _i = {...item};
        _i.text = _i.label;
        _i.action = () => callback(_i.value);
        return _i; 
    })

    // return(<>{JSON.stringify(menu, null, 2)}</>)

   
    
    return(<><Popup title={"Used Conditions"} width={"auto"} callback={callback} component={<Menu keyName="value" show_keys route={route} menu={menu} selected={selected} setSelected={setSelected} callback={(e) => callback(e.value)}  />} /></>)
}